import styled from 'styled-components';

import {
  margin,
  MarginProps,
  flex,
  FlexProps,
  gap,
  GapProps,
} from '../../../components/styles';

type Props = {
  column?: 'two' | 'three';
  reversal?: boolean;
};

const Comment = styled.div<Props>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: ${({ theme }) => theme.spaces.l};
  order: ${({ reversal }) => reversal && '2'};

  ${({ theme }) =>
    theme.screen.sp({
      order: '1',
    })}
`;

const Image = styled.div``;

const Root = styled.div<Props & MarginProps & FlexProps & GapProps>`
  margin: ${({ theme }) => theme.spaces.xl} 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  gap: ${({ theme }) => theme.spaces.xxl};

  ${margin};
  ${flex};
  ${gap};

  ${({ theme }) =>
    theme.screen.sp({
      gridTemplateColumns: 'inherit',
    })};
`;

export const Rows = Object.assign(Root, { Comment, Image });
